define('modules/home/models/alert.summary.model',[
    'client',
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function(Prospector, _, Backbone, BaseModel){
    var AlertSummaryModel = BaseModel.extend({
        debugName: 'AlertSummaryModel',
        base : 'user/alerts/summary',
        followingFilter: '0',
        monitoringFilter: '0',
        sortField: '',
        sortOrder: 'asc',
        useLocalStorage: true,
        onlyUseLocalStorageForFirstPull: true,
        urlRoot:function(){
            var url = 'prospector/v1/' + this.base;

            var params = [];
            if(this.query != undefined && this.query != ""){
                params.push("query="+this.query);
            }

            if(this.followingFilter != "0"){
                params.push("followingFilter="+this.followingFilter);
            }

            if(Prospector.SettingsApp.hasRoleMonitoring() && this.monitoringFilter!= "0"){
                params.push("monitoringFilter="+this.monitoringFilter);
            }

            if(this.sortField != undefined && this.sortField != ""){
                params.push("sortField="+this.sortField);
                params.push("sortOrder=" + this.sortOrder);
            }

            if(params.length != 0){
                for(var i = 0 ; i <params.length; i++){
                    if(i==0){
                        url += "?" + params[i];
                    }else{
                        url+= "&" + params[i];
                    }
                }
            }

            return window.utils.makeUrl( url);
        }
    });
    return AlertSummaryModel;
});


